import mixpanel from 'mixpanel-browser';

export const AuthEvents = {
  ConfirmAccountManualPaste: 'auth-confirm-account-manual-paste',
  ConfirmAccountView: 'auth-confirm-account-view',
  ForgotPasswordConfirmView: 'auth-forgot-password-confirm-view',
  ForgotPasswordSubmitView: 'auth-forgot-password-submit-view',
  ForgotPasswordView: 'auth-forgot-password-view',
  SignInView: 'auth-sign-in-view',
  SignUpView: 'auth-sign-up-view',
};

export const OnboardingEvents = {
  AcknowledgeDirectDebitAgreementView: 'onboarding-acknowledge-direct-debit-agreement-view',
  AcknowledgeDirectDebitAgreementConfirm: 'onboarding-acknowledge-direct-debit-agreement-confirm',
  AutoGetPaidNowConfirm: 'onboarding-auto-get-paid-now-confirm',
  AutoGetPaidNowDeny: 'onboarding-auto-get-paid-now-deny',
  AutoGetPaidNowView: 'onboarding-auto-get-paid-now-view',
  BankInfoPlaidView: 'onboarding-bank-info-plaid-view',
  BankInfoSelectionView: 'onboarding-bank-info-selection-view',
  BankInfoView: 'onboarding-bank-info-view',
  BusinessInfoView: 'onboarding-business-info-view',
  ConnectBankPlaidClick: 'onboarding-connect-bank-plaid-click',
  ConnectBankPlaidClickWithTransactions: 'onboarding-connect-bank-plaid-click-with-transactions',
  ConnectBankPlaidClose: 'onboarding-connect-bank-plaid-close',
  ConnectBankPlaidSuccess: 'onboarding-connect-bank-plaid-success',
  ConnectBankManualClick: 'onboarding-connect-bank-manual-click',
  ContactSupportClick: 'onboarding-contact-support-click',
  ContactSupportCopyEmailClick: 'onboarding-contact-support-copy-email-click',
  DataSharingAgreementView: 'onboarding-data-sharing-agreement-view',
  DirectDebitAgreementView: 'onboarding-direct-debit-agreement-view',
  FinishingErrorView: 'onboarding-finishing-error-view',
  FinishingLoadingView: 'onboarding-finishing-loading-view',
  FinishingSuccessView: 'onboarding-finishing-success-view',
  PartnerServiceAgreementView: 'onboarding-partner-service-agreement-view',
  Net30PaymentScheduleConfirm: 'onboarding-net-30-payment-schedule-confirm',
  Net30PaymentScheduleView: 'onboarding-net-30-payment-schedule-view',
  OnDemandScheduleView: 'onboarding-on-demand-schedule-view',
  PayOnApprovalConfirm: 'onboarding-pay-on-approval-confirm',
  PayOnApprovalView: 'onboarding-pay-on-approval-view',
  PaymentScheduleClick: 'onboarding-payment-schedule-click',
  PaymentScheduleView: 'onboarding-payment-schedule-view',
  TermsView: 'onboarding-terms-view',
  BankInfoContinueClick: 'onboarding-bank-info-continue-click',
  TermsIncompleteBankInfoRedirect: 'onboarding-terms-incomplete-bank-info-redirect',
  PartnerServiceAgreementIncompleteBankInfoRedirect: 'onboarding-partner-service-agreement-incomplete-bank-info-redirect',
  Submit: 'onboarding-submit',
  SubmitSuccess: 'onboarding-submit-success',
  SubmitError: 'onboarding-submit-error',
};

const FactoringEvents = {
  FactoringBannerView: 'dashboard-factoring-banner-view',
  FactoringBannerLearnMoreClick: 'dashboard-factoring-banner-learn-more-click',
  FactoringBannerDismiss: 'dashboard-factoring-banner-dismiss',
  FactoringPageView: 'dashboard-factoring-page-view',
  FactoringPageCtaClick: 'dashboard-factoring-page-cta-click',
  FactoringPageBackToDashboardClick: 'dashboard-factoring-page-back-to-dashboard-click',
  FactoringDetailsPageView: 'dashboard-factoring-details-page-view',
  FactoringDetailsPageSubmitClick: 'dashboard-factoring-details-page-submit-click',
  FactoringDetailsPageExitPromptView: 'dashboard-factoring-details-page-exit-prompt-view',
  FactoringDetailsPageExitPromptContinueClick: 'dashboard-factoring-details-page-exit-prompt-continue-click',
  FactoringDetailsPageExitPromptExitClick: 'dashboard-factoring-details-page-exit-prompt-exit-click',
  FactoringSuccessPageView: 'dashboard-factoring-success-page-view',
  FactoringSuccessPageDoneClick: 'dashboard-factoring-success-page-done-click',
  FactoringReviewBannerView: 'dashboard-factoring-review-banner-view',
  FactoringReviewBannerContactSupportClick: 'dashboard-factoring-review-banner-contact-support-click',
  FactoringReviewBannerDismiss: 'dashboard-factoring-review-banner-dismiss',
  FactoringPortalSetupBannerView: 'dashboard-factoring-portal-setup-banner-view',
  FactoringPortalSetupBannerStartSetupClick: 'dashboard-factoring-portal-setup-banner-start-setup-click',
  FactoringPortalSetupBannerDismiss: 'dashboard-factoring-portal-setup-banner-dismiss',
  FactoringPortalSetupDashboardView: 'dashboard-factoring-portal-setup-dashboard-view',
  FactoringPortalSetupAddPortalClick: 'dashboard-factoring-portal-setup-add-portal-click',
  FactoringPortalSetupAddPortalConnectClick: 'dashboard-factoring-portal-setup-add-portal-connect-click',
  FactoringPortalSetupSelectPortalClick: 'dashboard-factoring-portal-setup-select-portal-click',
  FactoringPortalSetupRemovePortalClick: 'dashboard-factoring-portal-setup-remove-portal-click',
  FactoringPortalSetupSelectStepClick: 'dashboard-factoring-portal-setup-select-step-click',
  FactoringPortalSetupAddBankAccountClick: 'dashboard-factoring-portal-setup-add-bank-account-click',
  FactoringPortalSetupLinkBankAccountConfirmClick: 'dashboard-factoring-portal-setup-link-bank-account-confirm-click',
  FactoringPortalSetupGrantAccessConfirmClick: 'dashboard-factoring-portal-setup-grant-access-confirm-click',
  FactoringPortalSetupAcceptPricingConfirmClick: 'dashboard-factoring-portal-setup-accept-pricing-confirm-click',
  FactoringPortalSetupMsaConfirmClick: 'dashboard-factoring-portal-setup-msa-confirm-click',
  FactoringPortalSetupReviewSummaryView: 'dashboard-factoring-portal-setup-review-summary-view',
  FactoringPortalSetupConnectedView: 'dashboard-factoring-portal-setup-connected-view',
  FactoringPortalSetupHowItWorksClick: 'dashboard-factoring-portal-setup-how-it-works-click',
  FactoringPortalSetupFaqClick: 'dashboard-factoring-portal-setup-faq-click',
  FactoringPortalSetupContactSupportClick: 'dashboard-factoring-portal-setup-contact-support-click',
  FactoringHowItWorksView: 'dashboard-factoring-how-it-works-view',
  FactoringHowItWorksGetInTouchClick: 'dashboard-factoring-how-it-works-get-in-touch-click',
};

const MultiPartnerUpsellEvents = {
  MultiPartnerUpsellConnectClick: 'dashboard-multi-partner-upsell-connect-click',
  MultiPartnerUpsellAgreementAccept: 'dashboard-multi-partner-upsell-agreement-accept',
  MultiPartnerUpsellConnected: 'dashboard-multi-partner-upsell-connected',
  MultiPartnerUpsellConnectFailed: 'dashboard-multi-partner-upsell-connect-failed',
  MultiPartnerUpsellDone: 'dashboard-multi-partner-upsell-done',
  MultiPartnerUpsellConfirmView: 'dashboard-multi-partner-upsell-confirm-view',
  MultiPartnerUpsellConfirmGotItClick: 'dashboard-multi-partner-upsell-confirm-got-it-click',
};

const DirectDebitDashboardEvents = {
  ConnectBankPlaidClick: 'dashboard-connect-bank-plaid-click',
  ConnectBankPlaidClickWithTransactions: 'dashboard-connect-bank-plaid-click-with-transactions',
  ConnectBankPlaidClose: 'dashboard-connect-bank-plaid-close',
  ConnectBankPlaidSuccess: 'dashboard-connect-bank-plaid-success',
  ConnectBankPrePlaidView: 'connect-bank-pre-plaid-view',
  DirectDebitFinishOnboardingSidebarCompletedView: 'dashboard-direct-debit-finish-onboarding-sidebar-completed-view',
  DirectDebitFinishOnboardingSidebarConfirmPricingClick: 'dashboard-direct-debit-finish-onboarding-sidebar-confirm-pricing-click',
  DirectDebitFinishOnboardingSidebarConnectBankClick: 'dashboard-direct-debit-finish-onboarding-sidebar-connect-bank-click',
  DirectDebitFinishOnboardingSidebarConnectBankActionClick: 'dashboard-direct-debit-finish-onboarding-sidebar-connect-bank-action-click',
  DirectDebitFinishOnboardingSidebarConnectBankPlaidClose: 'dashboard-direct-debit-finish-onboarding-sidebar-connect-bank-plaid-close',
  DirectDebitFinishOnboardingSidebarConnectBankPlaidSuccess: 'dashboard-direct-debit-finish-onboarding-sidebar-connect-bank-plaid-success',
  DirectDebitFinishOnboardingSidebarConnectBankPlaidView: 'dashboard-direct-debit-finish-onboarding-sidebar-connect-bank-plaid-view',
  DirectDebitFinishOnboardingSidebarConnectBankTaskView: 'dashboard-direct-debit-finish-onboarding-sidebar-connect-bank-task-view',
  DirectDebitFinishOnboardingSidebarReviewPaymentScheduleClick: 'dashboard-direct-debit-finish-onboarding-sidebar-review-payment-schedule-click',
  DirectDebitFinishOnboardingSidebarReviewPaymentScheduleTaskView: 'dashboard-direct-debit-finish-onboarding-sidebar-review-payment-schedule-task-view',
  DirectDebitFinishOnboardingSidebarUploadW9Click: 'dashboard-direct-debit-finish-onboarding-sidebar-upload-w9-click',
  DirectDebitFinishOnboardingSidebarUploadW9Close: 'dashboard-direct-debit-finish-onboarding-sidebar-upload-w9-close',
  DirectDebitFinishOnboardingSidebarUploadW9Confirm: 'dashboard-direct-debit-finish-onboarding-sidebar-upload-w9-confirm',
  DirectDebitFinishOnboardingSidebarUploadW9View: 'dashboard-direct-debit-finish-onboarding-sidebar-upload-w9-view',
  DirectDebitFinishOnboardingSidebarUploadW9TaskView: 'dashboard-direct-debit-finish-onboarding-sidebar-upload-w9-task-view',
  DirectDebitFinishOnboardingSidebarUploadBankDocClick: 'dashboard-direct-debit-finish-onboarding-sidebar-upload-bank-doc-click',
  DirectDebitFinishOnboardingSidebarUploadBankDocClose: 'dashboard-direct-debit-finish-onboarding-sidebar-upload-bank-doc-close',
  DirectDebitFinishOnboardingSidebarUploadBankDocConfirm: 'dashboard-direct-debit-finish-onboarding-sidebar-upload-bank-doc-confirm',
  DirectDebitFinishOnboardingSidebarUploadBankDocView: 'dashboard-direct-debit-finish-onboarding-sidebar-upload-bank-doc-view',
  DirectDebitFinishOnboardingSidebarUploadBankDocTaskView: 'dashboard-direct-debit-finish-onboarding-sidebar-upload-bank-doc-task-view',
  DirectDebitFinishOnboardingSidebarBankVerificationClick: 'dashboard-direct-debit-finish-onboarding-sidebar-bank-verification-click',
  DirectDebitFinishOnboardingSidebarBankVerificationTaskView: 'dashboard-direct-debit-finish-onboarding-sidebar-bank-verification-task-view',
  DirectDebitFinishOnboardingSidebarLinkMoreAccountsClick: 'dashboard-direct-debit-finish-onboarding-sidebar-link-more-accounts-click',
  DirectDebitFinishOnboardingSidebarInviteTeamMemberClick: 'dashboard-direct-debit-finish-onboarding-sidebar-invite-team-member-click',
  DirectDebitFinishOnboardingSidebarManualConnectionClick: 'dashboard-direct-debit-finish-onboarding-sidebar-manual-connection-click',
  DirectDebitFinishOnboardingSidebarAutoAdvance: 'dashboard-direct-debit-finish-onboarding-sidebar-auto-advance',
  DirectDebitFinishOnboardingSidebarView: 'dashboard-direct-debit-finish-onboarding-sidebar-view',
  PartnerProgramSetupSidebarView: 'dashboard-partner-program-setup-sidebar-view',
  DirectDebitHowItWorksClick: 'dashboard-direct-debit-how-it-works-click',
  DirectDebitHowItWorksView: 'dashboard-direct-debit-how-it-works-view',
  DirectDebitSidebarReviewServiceAgreementClick: 'dashboard-direct-debit-sidebar-review-service-agreement-click',
  DirectDebitSidebarReviewServiceAgreementClose: 'dashboard-direct-debit-sidebar-review-service-agreement-close',
  DirectDebitSidebarReviewServiceAgreementConfirm: 'dashboard-direct-debit-sidebar-review-service-agreement-confirm',
  DirectDebitSidebarReviewServiceAgreementView: 'dashboard-direct-debit-sidebar-review-service-agreement-view',
  DirectDebitSidebarReviewServiceAgreementTaskView: 'dashboard-direct-debit-sidebar-review-service-agreement-task-view',
  DirectDebitPayOnApprovalPaymentScheduleModalView: 'dashboard-direct-debit-pay-on-approval-payment-schedule-modal-view',
  DirectDebitPayOnApprovalPaymentScheduleModalClose: 'dashboard-direct-debit-pay-on-approval-payment-schedule-modal-close',
  DirectDebitPayOnApprovalPaymentScheduleModalAcceptClick: 'dashboard-direct-debit-pay-on-approval-payment-schedule-modal-accept-click',
  DirectDebitOnDemandPaymentScheduleModalView: 'dashboard-direct-debit-on-demand-payment-schedule-modal-view',
  DirectDebitOnDemandPaymentScheduleModalClose: 'dashboard-direct-debit-on-demand-payment-schedule-modal-close',
  DirectDebitOnDemandPaymentScheduleModalAcceptClick: 'dashboard-direct-debit-on-demand-payment-schedule-modal-accept-click',
  ReconnectBankAccountClick: 'dashboard-reconnect-bank-account-click',
  ReconnectBankAccountClose: 'dashboard-reconnect-bank-account-close',
  ReconnectBankAccountError: 'dashboard-reconnect-bank-account-error',
  ReconnectBankAccountSuccess: 'dashboard-reconnect-bank-account-success',
};

export const DashboardEvents = {
  AccountView: 'dashboard-account-view',
  BankStatementsUploadView: 'dashboard-bank-statements-upload-view',
  BankStatementsUploadConfirm: 'dashboard-bank-statements-upload-confirm',
  BankStatementsUploadClose: 'dashboard-bank-statements-upload-close',
  OpenInvoicesTabClick: 'dashboard-open-invoices-tab-click',
  SidebarAcceptDataSharingAgreementClick: 'dashboard-sidebar-accept-data-sharing-agreement-click',
  SidebarAcceptDataSharingAgreementConfirm: 'dashboard-sidebar-accept-data-sharing-agreement-confirm',
  SidebarAcceptDataSharingAgreementTaskView: 'dashboard-sidebar-accept-data-sharing-agreement-task-view',
  ConfigureBankAccountsModalView: 'dashboard-configure-bank-accounts-modal-view',
  ConfigureBankAccountsModalSubmitClick: 'dashboard-configure-bank-accounts-modal-submit-click',
  ConfigureBankAccountsModalSuccess: 'dashboard-configure-bank-accounts-modal-success',
  ConfigureBankAccountsModalError: 'dashboard-configure-bank-accounts-modal-error',
  ConfigureBankAccountsModalClose: 'dashboard-configure-bank-accounts-modal-close',
  DirectDebitAuthorizationModalView: 'dashboard-direct-debit-authorization-modal-view',
  DirectDebitAuthorizationModalConfirm: 'dashboard-direct-debit-authorization-modal-confirm',
  DirectDebitAuthorizationModalClose: 'dashboard-direct-debit-authorization-modal-close',
  DirectDebitAuthorizationModalError: 'dashboard-direct-debit-authorization-modal-error',
  BankVerificationModalView: 'dashboard-bank-verification-modal-view',
  BankVerificationModalSubmitClick: 'dashboard-bank-verification-modal-submit-click',
  BankVerificationModalSuccess: 'dashboard-bank-verification-modal-success',
  BankVerificationModalError: 'dashboard-bank-verification-modal-error',
  BankVerificationModalClose: 'dashboard-bank-verification-modal-close',
  AutoGetPaidNowClose: 'dashboard-auto-get-paid-now-close',
  AutoGetPaidNowConfirm: 'dashboard-auto-get-paid-now-confirm',
  AutoGetPaidNowDisable: 'dashboard-auto-get-paid-now-disable',
  AutoGetPaidNowLearnMoreClick: 'dashboard-auto-get-paid-now-learn-more-click',
  AutoGetPaidNowView: 'dashboard-auto-get-paid-now-view',
  BulkGetPaidNowClick: 'dashboard-bulk-get-paid-now-click',
  BulkGetPaidNowClose: 'dashboard-bulk-get-paid-now-close',
  BulkGetPaidNowConfirm: 'dashboard-bulk-get-paid-now-confirm',
  BulkGetPaidNowHover: 'dashboard-bulk-get-paid-now-hover',
  BulkGetPaidNowInterstitialConfirm: 'dashboard-bulk-get-paid-now-interstitial-confirm',
  BulkGetPaidNowView: 'dashboard-bulk-get-paid-now-view',
  BulkOnDemandClick: 'dashboard-bulk-on-demand-click',
  BulkOnDemandClose: 'dashboard-bulk-on-demand-close',
  BulkOnDemandConfirm: 'dashboard-bulk-on-demand-confirm',
  BulkOnDemandHover: 'dashboard-bulk-on-demand-hover',
  BulkOnDemandView: 'dashboard-bulk-on-demand-view',
  CollectionsTabClick: 'dashboard-collections-tab-click',
  AdjustmentsTabClick: 'dashboard-adjustments-tab-click',

  PayOnApprovalByRequestClick: 'dashboard-pay-on-approval-by-request-click',
  PayOnApprovalByRequestClose: 'dashboard-pay-on-approval-by-request-close',
  PayOnApprovalByRequestConfirm: 'dashboard-pay-on-approval-by-request-confirm',

  FeedbackUIConfirm: 'dashboard-feedback-ui-confirm',
  FeedbackUIDismiss: 'dashboard-feedback-ui-dismiss',
  FeedbackUIErrorShown: 'dashboard-feedback-ui-error-shown',
  FeedbackUIProductOrFeatureRequestShown: 'dashboard-feedback-ui-step-product-or-feature-request-shown',
  FeedbackUIRatingShown: 'dashboard-feedback-ui-step-rating-shown',
  FeedbackUISuccessShown: 'dashboard-feedback-ui-success-shown',
  GetPaidNowClick: 'dashboard-get-paid-now-click',
  GetPaidNowClose: 'dashboard-get-paid-now-close',
  GetPaidNowConfirm: 'dashboard-get-paid-now-confirm',
  GetPaidNowHover: 'dashboard-get-paid-now-hover',
  GetPaidNowInterstitialClose: 'dashboard-get-paid-now-interstitial-close',
  GetPaidNowInterstitialSingleConfirm: 'dashboard-get-paid-now-interstitial-confirm',
  InvoicesTabClick: 'dashboard-invoices-tab-click',
  MesaOnDemandClick: 'dashboard-mesa-on-demand-click',
  MesaOnDemandClose: 'dashboard-mesa-on-demand-close',
  MesaOnDemandConfirm: 'dashboard-mesa-on-demand-confirm',
  OverviewView: 'dashboard-overview-view',
  PaidInvoicesTabClick: 'dashboard-paid-invoices-tab-click',
  PaymentsTabClick: 'dashboard-payments-tab-click',
  RequestInflightsClick: 'dashboard-request-inflights-click',
  RequestInflightsClose: 'dashboard-request-inflights-close',
  RequestInflightsConfirm: 'dashboard-request-inflights-confirm',
  SelectiveGetPaidNowCheck: 'dashboard-selective-get-paid-now-check',
  SelectiveGetPaidNowClose: 'dashboard-selective-get-paid-now-close',
  SelectiveGetPaidNowConfirm: 'dashboard-selective-get-paid-now-confirm',
  SelectiveGetPaidNowView: 'dashboard-selective-get-paid-now-view',
  SelectiveOnDemandClose: 'dashboard-selective-on-demand-close',
  SelectiveOnDemandConfirm: 'dashboard-selective-on-demand-confirm',
  SelectiveOnDemandView: 'dashboard-selective-on-demand-view',
  SupportView: 'dashboard-support-view',
  UploadInvoiceDocumentModalClose: 'dashboard-upload-invoice-document-modal-view',
  UploadInvoiceDocumentModalConfirm: 'dashboard-upload-invoice-document-modal-confirm',
  UploadInvoiceDocumentModalView: 'dashboard-upload-invoice-document-modal-view',
  UploadInvoiceRowActionButtonClick: 'dashboard-upload-invoice-row-action-button-click',
  WelcomeModalForcedExit: 'welcome-modal-forced-exit',
  WelcomeModalHowMesaWorksView: 'welcome-modal-step-how-mesa-works-view',
  WelcomeModalInflightsView: 'welcome-modal-step-inflights-view',
  WelcomeModalInviteColleaguesView: 'welcome-modal-step-invite-colleagues-view',
  WelcomeModalWelcomeView: 'welcome-modal-step-welcome-view',
  ProgramPromotionView: 'dashboard-program-promotion-view',
  ProgramPromotionLearnMoreClick: 'dashboard-program-promotion-learn-more-click',
  ProgramPromotionDismiss: 'dashboard-program-promotion-dismiss',
  ProgramPromotionGetStartedClick: 'dashboard-program-promotion-get-started-click',
  ProgramPromotionCompleted: 'dashboard-program-promotion-completed',
  ...FactoringEvents,
  ...MultiPartnerUpsellEvents,
  ...DirectDebitDashboardEvents,
};

export const DashboardFromEmailEvents = {
  InvoiceImportSummaryBulkGetPaidNowView: 'email-invoice-import-summary-bulk-get-paid-now-view',
  PaymentSummaryBulkGetPaidNowView: 'email-payment-summary-bulk-get-paid-now-view',
  PaymentSummaryAutoGetPaidNowView: ' email-payment-summary-auto-get-paid-now-view',
  OnDemandReminderView: ' email-on-demand-reminder-view',
};

export const AllEvents = {
  ...AuthEvents,
  ...OnboardingEvents,
  ...DashboardEvents,
  ...DashboardFromEmailEvents,
};

export enum Experiments {
  PlaidOnboarding = 'plaid-onboarding-experiment',
  DeferredOnboarding = 'deferred-onboarding-experiment',
}

export const ExperimentVariants = {
  [Experiments.PlaidOnboarding]: {
    PLAID_SELECTION: 'PLAID_SELECTION',
    MANUAL_SELECTION: 'MANUAL_SELECTION',
  },
  [Experiments.DeferredOnboarding]: {
    CONTROL: 'CONTROL',
    DEFERRED: 'DEFERRED',
  },
} as const;

type VariantMap = {
  [K in keyof typeof ExperimentVariants]:
  typeof ExperimentVariants[K][keyof typeof ExperimentVariants[K]];
};

type AllEventTypeValues = typeof AllEvents[keyof typeof AllEvents];

type GenericEventData = Record<string, unknown>;

/**
 * Uses the cognito:username attribute since analytics is collected prior to a
 * user converting to a vendor in our system.
 */
export const setAnalyticsUserId = (userId: string) => {
  try {
    mixpanel.identify(userId);
  } catch (err) {
    console.error(err);
  }
};

// Persists across identify() calls, unlike a plain event property, so it
// survives the cognitoUsername -> vendorId identity switch at vendor creation.
export const registerAnalyticsSuperProperties = (properties: Record<string, unknown>) => {
  try {
    mixpanel.register(properties);
  } catch (err) {
    console.error(err);
  }
};

export const addAnalyticsGroup = (groupKey: string, groupId: number | string) => {
  try {
    mixpanel.add_group(groupKey, groupId.toString());
  } catch (err) {
    console.error(err);
  }
};

export const removeAnalyticsGroup = (groupKey: string, groupId: number | string) => {
  try {
    mixpanel.remove_group(groupKey, groupId.toString());
  } catch (err) {
    console.error(err);
  }
};

export const trackEvent = <T = GenericEventData>(eventName: AllEventTypeValues, eventData: Partial<T> = {}) => {
  try {
    mixpanel.track(eventName, eventData);
  } catch (err) {
    console.error(err);
  }
};

export const trackExperiment = <E extends keyof VariantMap>(
  experimentName: E,
  variant: VariantMap[E],
  eventData: Partial<GenericEventData> = {}
) => {
  try {
    trackEvent(experimentName, {
      ...eventData,
      experiment: experimentName,
      variant,
    });
  } catch (err) {
    console.error(err);
  }
};

export const reset = () => {
  try {
    mixpanel.reset();
  } catch (err) {
    console.error(err);
  }
};